import React from 'react';
import styles from './ListingCard.module.css';
import { useTheme } from '../../../contexts/ThemeContext';

const ListingCard = ({
    title,
    subtitle,
    icon,
    onClick,
    actions,
    className = "",
    children,
    variant = "default",
    align = "center",
    iconVariant = "primary",
    size = "medium",
    fontSize
}) => {
    const { theme } = useTheme();

    return (
        <div
            className={`${styles.card} ${styles[variant]} ${styles[align]} ${styles[size]} ${className}`}
            onClick={onClick}
            role={onClick ? "button" : "article"}
            tabIndex={onClick ? 0 : undefined}
        >
            <div className={styles.glow} />

            {icon && (
                <div className={`${styles.iconContainer} ${styles[`icon-${iconVariant}`]}`}>
                    {icon}
                </div>
            )}

            <div className={styles.content} style={fontSize ? { fontSize } : {}}>
                {title && <h3 className={styles.title}>{title}</h3>}
                {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
                {children}
            </div>

            {actions && (
                <div className={styles.actions}>
                    {actions}
                </div>
            )}

            <div className={styles.borderEffect} />
        </div>
    );
};

export default ListingCard;
